var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.68724 0 0 4.49423 0 10.2308V27.7692C0 33.5058 7.68724 38 17.5 38C27.3128 38 35 33.5058 35 27.7692V10.2308C35 4.49423 27.3128 0 17.5 0ZM32.0833 19C32.0833 20.7575 30.6469 22.5497 28.144 23.9181C25.3258 25.4582 21.5451 26.3077 17.5 26.3077C13.4549 26.3077 9.67422 25.4582 6.85599 23.9181C4.35313 22.5497 2.91667 20.7575 2.91667 19V15.96C6.02656 18.7004 11.344 20.4615 17.5 20.4615C23.656 20.4615 28.9734 18.6931 32.0833 15.96V19ZM6.85599 5.31269C9.67422 3.7726 13.4549 2.92308 17.5 2.92308C21.5451 2.92308 25.3258 3.7726 28.144 5.31269C30.6469 6.68106 32.0833 8.47327 32.0833 10.2308C32.0833 11.9883 30.6469 13.7805 28.144 15.1488C25.3258 16.6889 21.5451 17.5385 17.5 17.5385C13.4549 17.5385 9.67422 16.6889 6.85599 15.1488C4.35313 13.7805 2.91667 11.9883 2.91667 10.2308C2.91667 8.47327 4.35313 6.68106 6.85599 5.31269ZM28.144 32.6873C25.3258 34.2274 21.5451 35.0769 17.5 35.0769C13.4549 35.0769 9.67422 34.2274 6.85599 32.6873C4.35313 31.3189 2.91667 29.5267 2.91667 27.7692V24.7292C6.02656 27.4696 11.344 29.2308 17.5 29.2308C23.656 29.2308 28.9734 27.4623 32.0833 24.7292V27.7692C32.0833 29.5267 30.6469 31.3189 28.144 32.6873Z",
    fill: "url(#paint0_linear_880_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_880_26",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273979"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlus);
export default __webpack_public_path__ + "static/media/carePlus.b2ed57d11234214eba180c078bb73057.svg";
export { ForwardRef as ReactComponent };